module.exports = __webpack_public_path__ + "static/media/1008478.ce5a2936.png";